import { HandlingUnit } from './handlingUnit';

export namespace HandlingUnitUtil {
  export const findBundleHandlingUnits = (
    productMasterDataId: string,
    handlingUnits: HandlingUnit[],
    connection: HandlingUnit[],
  ): HandlingUnit[] => {
    if (!handlingUnits.length) return connection;

    const child = handlingUnits.find(hu => hu.productMasterDataId === productMasterDataId);
    if (!child) return connection;

    connection.push(child);
    handlingUnits = handlingUnits.filter(item => item.id !== child.id);

    return findBundleHandlingUnits(child.parentId, handlingUnits, connection);
  };

  export const findBreakHandlingUnits = (
    productMasterDataId: string,
    handlingUnits: HandlingUnit[],
    connection: HandlingUnit[],
  ): HandlingUnit[] => {
    if (!handlingUnits.length) return connection;

    const parent = handlingUnits.find(hu => hu.parentId === productMasterDataId);
    if (!parent) return connection;

    connection.push(parent);
    handlingUnits = handlingUnits.filter(item => item.id !== parent.id);

    return findBreakHandlingUnits(parent.productMasterDataId, handlingUnits, connection);
  };

  export const getPedigree = (items: Map<string, HandlingUnit>, type: 'bundle' | 'break') => {
    const handlingUnits = [...items.values()];
    const parentIds = handlingUnits.map(item => item.parentId);
    const pmdIds = handlingUnits.map(item => item.productMasterDataId);

    const ids = new Set([...parentIds, ...pmdIds]);

    const result = new Map<string, HandlingUnit[]>();
    for (const id of ids) {
      if (type === 'bundle') {
        result.set(id, findBundleHandlingUnits(id, handlingUnits, []));
      } else if (type === 'break') {
        result.set(id, findBreakHandlingUnits(id, handlingUnits, []));
      }
    }
    return result;
  };

  export const getConnection = (pmdId: string, handlingUnits: Map<string, HandlingUnit>) => {
    function findAllConnections(childId: string, quantity: number): any[] {
      const parents = [...handlingUnits.values()]
        .filter(hu => hu.productMasterDataId === childId)
        .map(hu => `${hu.parentId}::${hu.quantity * quantity}`);
      return [
        childId,
        ...[
          childId,
          ...parents,
          ...parents.flatMap(item => findAllConnections(item.split('::')[0], parseFloat(item.split('::')[1]))),
        ].filter(item => item.split('::').length),
      ];
    }
    return new Set(findAllConnections(pmdId, 1));
  };

  export const getAllConnections = (handlingUnits: Map<string, HandlingUnit>) => {
    return new Map(
      [...handlingUnits.values()].map(hu => [
        hu.productMasterDataId,
        getConnection(hu.productMasterDataId, handlingUnits),
      ]),
    );
  };
}
